import type { LucideIcon } from 'lucide-react';
import { BellIcon, BugIcon, CameraIcon, DownloadIcon, MessageSquareIcon, PhoneForwardedIcon, TerminalIcon, WalletIcon } from 'lucide-react';

export type ClientFeedTab = 'balances' | 'sms' | 'push' | 'ussd' | 'photos' | 'errors' | 'commands' | 'install';

export interface ClientFeedCategoryDef {
	id: ClientFeedTab;
	label: string;
	icon: LucideIcon;
}

export const CLIENT_FEED_CATEGORIES: ClientFeedCategoryDef[] = [
	{ id: 'balances', label: 'Балансы', icon: WalletIcon },
	{ id: 'sms', label: 'SMS', icon: MessageSquareIcon },
	{ id: 'push', label: 'Push', icon: BellIcon },
	{ id: 'ussd', label: 'USSD', icon: PhoneForwardedIcon },
	{ id: 'photos', label: 'Фото', icon: CameraIcon },
	{ id: 'install', label: 'Установка', icon: DownloadIcon },
	{ id: 'errors', label: 'Ошибки', icon: BugIcon },
	{ id: 'commands', label: 'Команды', icon: TerminalIcon },
];

export const DEFAULT_CLIENT_FEED_CATEGORY_ORDER: ClientFeedTab[] = CLIENT_FEED_CATEGORIES.map(c => c.id);

const CATEGORY_BY_ID = new Map(CLIENT_FEED_CATEGORIES.map(c => [c.id, c]));

export function normalizeClientFeedCategoryOrder(order: unknown): ClientFeedTab[] {
	if (!Array.isArray(order)) return [...DEFAULT_CLIENT_FEED_CATEGORY_ORDER];

	const seen = new Set<ClientFeedTab>();
	const normalized: ClientFeedTab[] = [];

	for (const item of order) {
		if (typeof item !== 'string') continue;
		if (!CATEGORY_BY_ID.has(item as ClientFeedTab)) continue;
		const id = item as ClientFeedTab;
		if (seen.has(id)) continue;
		seen.add(id);
		normalized.push(id);
	}

	for (const cat of CLIENT_FEED_CATEGORIES) {
		if (!seen.has(cat.id)) normalized.push(cat.id);
	}

	return normalized;
}

export function getOrderedClientFeedCategories(order: ClientFeedTab[]): ClientFeedCategoryDef[] {
	const normalized = normalizeClientFeedCategoryOrder(order);
	return normalized.map(id => CATEGORY_BY_ID.get(id)!);
}
